// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unitablelist .el-table__header tr th{background-color:#ebebec!important;padding:.156vw 0!important;font-size:.729vw;font-family:Microsoft YaHei;font-weight:400;color:#555!important;height:1.875vw}", ""]);
// Exports
module.exports = exports;
